// extracted by mini-css-extract-plugin
module.exports = {"button":"LandingPageButton_button__1bioS","primary":"LandingPageButton_primary__apaMP","secondary":"LandingPageButton_secondary__1VB5a"};